// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__27oMP","consentsList":"PatientConsents_consentsList__2TaTP","consentsListEmpty":"PatientConsents_consentsListEmpty__227Gk"};